import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { autoinject } from "aurelia-dependency-injection";

//Load styles
require("./layout-link-expired.scss");

@autoinject
export class LayoutLinkExpired {

    public crewWelfareUrl: string;

    constructor(private configService: ConfigService) {
        this.crewWelfareUrl = this.configService.config.urls.crewWelfareUrl;
    }
}